import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToBytes'
})
export class ConvertToBytesPipe implements PipeTransform {
  transform(fileSize: number, decimalPoints = 2): string {
    if (!fileSize) return '0 Bytes';
    const k = 1024;
    const dm = decimalPoints < 0 ? 0 : decimalPoints;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(fileSize) / Math.log(k));
    return `${parseFloat((fileSize / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }
}
